export const routingHistoryTheme = {
  borderRadius: '8px',
  container: 'palette.surface.2',
  historyItem: {
    active: {
      bg: 'palette.surface.4',
      borderColor: 'palette.primary.40',
      borderRadius: '12px',
      borderWidth: '1px',
    },
    base: {
      bg: 'palette.surface.3',
      borderColor: 'palette.surface.3',
      borderRadius: '12px',
      borderWidth: '1px',
    },
  },
  table: {
    bg: 'palette.surface.3',
    borderRadius: '12px',
    cell: 'palette.tertiary.60',
    row: {
      borderColor: 'palette.tertiary.10',
      borderWidth: '1px',
    },
    titleCell: {
      borderColor: 'palette.tertiary.5',
      borderWidth: '1px',
      text: 'palette.tertiary.90',
    },
  },
  text: 'palette.tertiary.80',
};
